export default "__VITE_ASSET__CXNwu2gQ__"